import BaseModel from './BaseModel'
import Location from './Location'

export default class LocationHours extends BaseModel {

  static entity = 'location_hours'
  static primaryKey = 'ID'

  // fields
  declare ID: number
  declare locationID: number
  declare dayOfWeek: string
  declare openLocal: string | null
  declare closeLocal: string | null

  // relationships
  declare location: Location

  static fields() {
    return {
      
      // fields
      ID: this.number(null),
      locationID: this.number(null),
      dayOfWeek: this.string(null),
      openLocal: this.string(null).nullable(),
      closeLocal: this.string(null).nullable(),

      // relationships
      location: this.belongsTo(Location, 'locationID'),

    }
  }

}
